import { SETTINGS } from "../config";

export default function GetFirstRequestDate ( date )  {
    let requestDate = new Date( date );
    requestDate.setDate(SETTINGS.FIRST_REQUEST_DATE.DAYS + requestDate.getDate());
    requestDate.setHours(SETTINGS.FIRST_REQUEST_DATE.HOURS);
    requestDate.setMinutes(0);
    requestDate.setSeconds(0);
    return requestDate;
}